import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/ShoppingCart/Detail/Index';
import useTranslation from 'hooks/useTranslation';
import { AppearanceList } from 'types/ShoppingCart/AppearanceList';
import { ProductList } from 'types/ShoppingCart/ProductList';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';

interface IProps extends RecipeErpViewComponentProps {}

export default function ProductsTabTemp(props: IProps) {
	const { classes } = useStyles();
	const { tl } = useTranslation();
	const { cart } = props;

	function renderProductsTable(products: ProductList.Type) {
		return (
			<table className="table">
				<thead>
					<tr>
						<th>ingredient-name</th>
						<th>store</th>
						<th>price</th>
						<th>quantity</th>
						<th>priceXquantity</th>
					</tr>
				</thead>
				<tbody>
					{products.map((e, i) => {
						return (
							<tr key={i}>
								<td>{tl(e.ingredient.name)}</td>
								<td>{e.store}</td>
								<td>{e.price}</td>
								<td>{e.quantity}</td>
								<td>{e.quantity * e.price}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	}

	function renderAppearancesTable(appearances: AppearanceList.Type) {
		return (
			<table className="table">
				<thead>
					<tr>
						<th>id</th>
						<th>name</th>
						<th>type</th>
						<th>quantity</th>
					</tr>
				</thead>
				<tbody>
					{appearances.map((e, i) => {
						return (
							<tr key={i}>
								<td>{e.id}</td>
								<td>{tl(e.name)}</td>
								<td>{e.type}</td>
								<td>{e.quantity}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	}

	return (
		<div className={classes.container}>
			<div>
				<h3>appearances</h3>
				{renderAppearancesTable(cart.appearances)}
			</div>
			<div>
				<h3>products normal</h3>
				{renderProductsTable(cart.products)}
			</div>
			<div>
				<h3>products merged Quantity</h3>
				{renderProductsTable(ProductList.mergeQuantity(cart.products))}
			</div>
			<div>
				<h3>calculated Price</h3>
				{ShoppingCart.getTotalPrice(cart, 'USD')}
			</div>
		</div>
	);
}

export const useStyles = tss.create({
	container: {
		marginTop: '20px',
		display: 'none',
		flexDirection: 'column',
		gap: '20px',
	},
});
